<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import type BenefitsBoxItem from './benefitsBoxItem.svelte';
	import Blok from '../blok.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			items: Array<ISbStoryData<BenefitsBoxItem>>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="grid grid-cols-1 items-center justify-between gap-3 rounded-xl border border-brown-5 bg-brown-6 p-3 xs:grid-cols-2 sm:gap-5"
>
	{#each content.items as item}
		<Blok content={item} />
	{/each}
</div>
